import _BaseUserProfile from 'Models/UserProfile/_BaseUserProfile';

export default class AutoInsuranceExpDate extends _BaseUserProfile {
  component = 'DateCalendar';
  props = {
    title: 'Expiration Date of Auto Insurance:',
    errorMessage: 'Please Select Date',
    additionalFormInModal: false,
  };
}
